import React from 'react';
import { lazy } from 'react-loosely-lazy';
import Placeholder from '@atlassian/jira-placeholder';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import type { Props } from './types';

const PACKAGE_NAME = 'businessUnscheduledItemsInCalendarView';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const UnscheduledSidebar = lazy(
	() => import(/* webpackChunkName: "async-jwm-calendar-unscheduled-sidebar" */ './index'),
);

const AsyncUnscheduledSidebar = (props: Props) => (
	<ContextualAnalyticsData sourceType={SCREEN} sourceName={PACKAGE_NAME}>
		<Placeholder name="unscheduled-side-bar" fallback={null}>
			<UnscheduledSidebar {...props} />
		</Placeholder>
	</ContextualAnalyticsData>
);

export default AsyncUnscheduledSidebar;
